<div class="flex flex-col">
  <div class="grid grid-cols-2 gap-2 items-center">
    <div>
      <div *ngIf="!addingExperience" class="flex flex-col md:flex-row gap-1">
        <span class="font-semibold">Management</span>
        <span class="font-semibold">Experiences</span>
      </div>

      <div *ngIf="newExperienceCreated" class="flex flex-col md:flex-row gap-1">
        <span class="font-semibold">Add</span>
        <span class="font-semibold">Experience</span>
      </div>

      <div *ngIf="addingExperience && !newExperienceCreated" class="flex flex-col md:flex-row gap-1">
        <span class="font-semibold">Update</span>
        <span class="font-semibold">Experience</span>
      </div>
    </div>

    <div class="gap-2 flex justify-self-end items-center" *ngIf="!addingExperience">
      <span *ngIf="experiences.length > 0 && !locked">Click Entry to Manage</span>
      <span *ngIf="locked">Click Entry to View</span>

      <button type="button" *ngIf="!locked || isChange || renewal"
              mat-button color="primary" (click)="createExperience()">Add</button>

      <button type="button" mat-button color="primary"
        (click)="getExperience(!includeArchived)">{{includeArchived? 'Hide Archived' : 'Show Archived'}}</button>
    </div>
  </div>

  <div class="flex flex-col" *ngIf="!addingExperience" [@slideLeft]>
    <mat-table [dataSource]="experienceSource" matSort #experienceSort="matSort" aria-label="Management Experience" class="portal-table">
      <ng-container matColumnDef="company">
        <mat-header-cell *matHeaderCellDef mat-sort-header="">Company</mat-header-cell>
        <mat-cell *matCellDef="let experience" (click)="selectExperience(experience)">
          <span class="mobile-label">Company</span>
          {{ experience.company }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="jobTitle">
        <mat-header-cell *matHeaderCellDef>Job Title</mat-header-cell>
        <mat-cell *matCellDef="let experience" (click)="selectExperience(experience)">
          <span class="mobile-label">Title</span>
          <span>{{ experience.jobTitle }}</span>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="phone">
        <mat-header-cell *matHeaderCellDef>Phone</mat-header-cell>
        <mat-cell *matCellDef="let experience" (click)="selectExperience(experience)">
          <span class="mobile-label">Phone</span>
          <div class="flex flex-col">
            <span>{{ experience.phone | mask: '000-00-0000' }}</span>
          </div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let experience">
          <div class="flex flex-row justify-start items-center">
            <button *ngIf="!locked" type="button" mat-icon-button [color]="experience.archived? 'primary' : 'warn'" (click)="archiveExperience(experience, !experience.archived)"
                    [matTooltip]="experience.archived? 'Un-Archive Experience' : 'Archive Experience'" matTooltipShowDelay="500" matTooltipHideDelay="200">
              <mat-icon *ngIf="!experience.archived" fontIcon="archive"></mat-icon>
              <mat-icon *ngIf="experience.archived" fontIcon="unarchive"></mat-icon>
            </button>
            <button *ngIf="!locked" type="button" mat-icon-button color="warn" (click)="confirmDelete(experience.id)"
              matTooltip="Delete Management Experience" matTooltipShowDelay="500" matTooltipHideDelay="200">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="experienceColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: experienceColumns" class="portal-interactive-row"
               [ngClass]="row.archived? 'portal-archived' : ''"></mat-row>
    </mat-table>
    <mat-paginator [pageSizeOptions]="[5, 10, 20]" #experiencePaginator="matPaginator">
    </mat-paginator>
  </div>

  <div class="flex flex-col pt-4" *ngIf="addingExperience" [@slideLeft]>
    <form [formGroup]="experienceForm">
      <div class="flex flex-col gap-2">

        <div class="flex flex-col md:flex-row gap-2">
          <div class="flex flex-col gap-2 md:w-1/2">
            <span class="font-semibold">Company</span>
            <mat-form-field>
              <mat-label>Company</mat-label>
              <input matInput formControlName="company">
              <mat-error *ngIf="experienceForm.get('company').invalid">
                Company is required
              </mat-error>
            </mat-form-field>
          </div>

          <div class="flex flex-col gap-2 md:w-1/2">
            <span class="font-semibold"><strong>Phone</strong></span>
            <mat-form-field>
              <mat-label>Phone</mat-label>
              <input matInput formControlName="phone" mask="000-000-0000">
              <mat-error *ngIf="experienceForm.get('phone').hasError('required')">
                A phone number is required
              </mat-error>
              <mat-error *ngIf="experienceForm.get('phone').hasError('pattern')">
                Phone should match format: 000-00-0000
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="flex flex-col md:flex-row gap-2">
          <div class="flex flex-col gap-2 md:w-1/2">
            <span class="font-semibold"><strong>Address</strong></span>
            <mat-form-field>
              <mat-label>Address</mat-label>
              <input matInput formControlName="address">
              <mat-error *ngIf="experienceForm.get('address').invalid">
                Address is required
              </mat-error>
            </mat-form-field>
          </div>

          <div class="flex flex-col gap-2 md:w-1/2">
            <span class="font-semibold"><strong>Supervisor</strong></span>
            <mat-form-field>
              <mat-label>Supervisor</mat-label>
              <input matInput formControlName="supervisor">
              <mat-error *ngIf="experienceForm.get('supervisor').invalid">
                Supervisor is required
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="flex flex-col gap-2 md:w-1/2">
          <span class="font-semibold"><strong>Job Title</strong></span>
          <mat-form-field>
            <mat-label>Job Title</mat-label>
            <input matInput formControlName="jobTitle">
            <mat-error *ngIf="experienceForm.get('jobTitle').invalid">
              Job title is required
            </mat-error>
          </mat-form-field>
        </div>

        <div class="flex flex-col gap-2">
          <span class="font-semibold"><strong>Management Duties</strong></span>
          <mat-form-field>
            <mat-label>Duties</mat-label>
            <textarea matInput formControlName="managementDuties" rows=3 ></textarea>
            <mat-error *ngIf="experienceForm.get('managementDuties').invalid">
              Duties are required
            </mat-error>
          </mat-form-field>
        </div>

        <div class="flex flex-col md:flex-row gap-2 md:items-center">
          <div class="flex flex-col md:w-1/2 gap-2">
            <span class="font-semibold">From</span>
            <mat-form-field>
              <input placeholder="mm/dd/yyyy" formControlName="from" matInput [matDatepicker]="from" [max]="sharedService.today"/>
              <mat-datepicker-toggle matSuffix [for]="from"></mat-datepicker-toggle>
              <mat-datepicker #from>
                <mat-datepicker-actions>
                  <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                  <button mat-button matDatepickerCancel>Cancel</button>
                </mat-datepicker-actions>
              </mat-datepicker>
              <mat-error *ngIf="experienceForm.get('from').invalid">
                Date is required
              </mat-error>
            </mat-form-field>
          </div>

          <div class="flex flex-col md:w-1/2 gap-2">
            <span class="font-semibold">To</span>
            <mat-form-field>
              <input placeholder="mm/dd/yyyy" formControlName="to" matInput [matDatepicker]="to" [max]="sharedService.today"/>
              <mat-datepicker-toggle matSuffix [for]="to"></mat-datepicker-toggle>
              <mat-datepicker #to>
                <mat-datepicker-actions>
                  <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                  <button mat-button matDatepickerCancel>Cancel</button>
                </mat-datepicker-actions>
              </mat-datepicker>
            </mat-form-field>
          </div>
        </div>

        <div class="flex flex-col md:flex-row gap-2 items-center">
          <label id="is-healthcare-field">
            Is this a health related field?
          </label>
          <mat-radio-group aria-labelledby="is-healthcare-field" formControlName="isHealthcareField">
            <mat-radio-button [value]="true">
              Yes
            </mat-radio-button>
            <mat-radio-button [value]="false">
              No
            </mat-radio-button>
          </mat-radio-group>

          <div class="flex flex-col gap-2 md:w-1/2" *ngIf="experienceForm.get('isHealthcareField').value">
            <span class="font-semibold"><strong>Health Care Field</strong></span>
            <mat-form-field>
              <mat-label>Field</mat-label>
              <input matInput formControlName="healthcareField">
            </mat-form-field>
            </div>
        </div>

        <div class="flex flex-col md:flex-row gap-2 items-center">
          <label id="may-contact-employer">
            May we contact your previous employer for a reference?
          </label>
          <mat-radio-group aria-labelledby="may-contact-employer" formControlName="mayContactEmployer">
            <mat-radio-button [value]="true">
              Yes
            </mat-radio-button>
            <mat-radio-button [value]="false">
              No
            </mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
    </form>

    <div class="gap-2 flex justify-end items-center">
      <button type="button" *ngIf="experienceForm.valid && experience.id > 0 && (!locked || isChange || renewal)"
              mat-button color="primary" (click)="saveExperience()">Save</button>

      <button type="button" *ngIf="experience.id > 0 && (!locked || isChange)"
        mat-button color="warn" (click)="confirmDelete(experience.id)">Delete</button>

      <button type="button" *ngIf="experience.id > 0 && !newExperienceCreated && !locked"
              mat-button color="warn" (click)="archiveExperience(experience, !experience.archived)">{{ experience.archived? 'Un-Archive' : 'Archive' }}</button>

      <button type="button" mat-button color="warn" (click)="toggleExperienceForm(false)">Close</button>
    </div>

  </div>
</div>
